import React from 'react';
import * as Styles from '../../styles/styles';

interface BottomActionBarFormProps extends React.HTMLProps<React.ReactNode> {
  cancelClickHandler: (event: React.MouseEvent<HTMLButtonElement>) => void;
  submitClickHandler?: () => void;
  submitting: boolean;
}

const BottomActionFormBar: React.FC<BottomActionBarFormProps> = (
  props: BottomActionBarFormProps
) => {
  const { cancelClickHandler, submitting, submitClickHandler } = props;

  return (
    <>
      <Styles.BottomAppBar position='fixed'>
        <Styles.ButtonGrid container>
          <Styles.BottomSaveButton
            type='submit'
            onClick={() => {
              if (submitClickHandler) submitClickHandler();
            }}
            disabled={submitting}
          >
            Save
          </Styles.BottomSaveButton>

          <Styles.BottomCancelButton
            type='button'
            onClick={cancelClickHandler}
            className='orangeLink'
          >
            CANCEL
          </Styles.BottomCancelButton>
        </Styles.ButtonGrid>
      </Styles.BottomAppBar>
    </>
  );
};

export default BottomActionFormBar;
